module.exports = __webpack_public_path__ + "Landingpage_Header_New.d650bc8a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/2018/desktop/headers/Landingpage_Header_New.png
// module id = RLhr
// module chunks = 0